import { serialize } from '@/@core/libs/serialize/util'
import Http from './http'

// Modules CRUD
export const modulesList = (params = '') => Http.get(`/modules${serialize(params)}`)
export const moduleByID = (params = '') => Http.get(`/modules/${params}`)
export const moduleCreate = (params = '') => Http.post('/modules', params)
export const moduleUpdate = (params = '') => Http.put(`/modules/${params.id}`, params)
export const moduleDestroy = (params = '') => Http.delete(`/modules/${params.id}`)

// Platform overview
export const modulePlatformOverview = (platformId = '') => Http.get(`/modules/platform/${platformId}/overview`)

// Company module access
export const companyModuleAccess = (companyId = '') => Http.get(`/modules/company/${companyId}/access`)
export const toggleCompanyModule = (params = '') => Http.post('/modules/company/toggle', params)
export const bulkToggleCompanyModules = (params = '') => Http.post('/modules/company/bulk-toggle', params)

// User module access
export const userModuleAccess = (userId = '') => Http.get(`/modules/user/${userId}/access`)
export const toggleUserModule = (params = '') => Http.post('/modules/user/toggle', params)
export const removeUserModuleAccess = (id = '') => Http.delete(`/modules/user/access/${id}`)

// Search helper for company access page
export const companiesList = (params = '') => Http.get(`/company${serialize(params)}`)
